module.exports = "/assets/data/fcf5d3aa27a16074879e93853e0075ad-RG20.data.json";